import {
  PLAYER_OPTIONS_HIDE_EPG,
  PLAYER_OPTIONS_SHOW_EPG,
  PLAYER_MODALS_Z_INDEX_INCREASE,
  PLAYER_MODALS_Z_INDEX_DECREASE,
} from './constants';

export const showEpg = () => dispatch => {
  dispatch({
    type: PLAYER_MODALS_Z_INDEX_INCREASE,
  });
  dispatch({
    type: PLAYER_OPTIONS_SHOW_EPG,
  });
};

export const hideEpg = () => (dispatch, getState) => {
  const state = getState();
  if (state?.Player?.OptionButtons?.epg?.isOpen) {
    dispatch({
      type: PLAYER_MODALS_Z_INDEX_DECREASE,
    });
    dispatch({
      type: PLAYER_OPTIONS_HIDE_EPG,
    });
  }
};
